module.exports = __webpack_public_path__ + "assets/img/24_1074.e0250f62.jpg";